var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1073_447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80732 1.32288L8.80724 1.32282C8.05018 0.693045 6.95119 0.693045 6.19413 1.32282L6.19407 1.32287L1.61717 5.1343C1.13567 5.53379 0.861475 6.12539 0.861475 6.75571V15.4496C0.861475 15.8344 1.16781 16.15 1.55229 16.15H13.4478C13.8323 16.15 14.1386 15.8344 14.1386 15.4496V6.75571C14.1386 6.12517 13.8628 5.53375 13.3831 5.13445L13.3414 5.09974H13.3414L8.80732 1.32288ZM2.49346 6.21787L2.49406 6.21737L7.06971 2.40588C7.06974 2.40585 7.06978 2.40582 7.06981 2.40579C7.31935 2.19853 7.68071 2.19856 7.93018 2.40588L12.5058 6.21737L12.5059 6.21746C12.6645 6.34928 12.7569 6.54538 12.7569 6.75606L12.7571 14.7493H9.99316V11.7809C9.99316 10.385 8.8777 9.24593 7.50003 9.24593C6.12224 9.24593 5.0069 10.3852 5.0069 11.7809V14.7496L2.24295 14.7495V6.75606C2.24295 6.54478 2.33427 6.34908 2.49346 6.21787ZM8.61158 14.7493H6.38855V11.7809C6.38855 11.1532 6.88978 10.6468 7.50008 10.6468C8.11038 10.6468 8.61161 11.1532 8.61161 11.7809L8.61158 14.7493Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1073_447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.66e3b0b5.svg";
export { ForwardRef as ReactComponent };